import PublicApi from '@/services/PublicApi'

export default {
  // Submits a contact enquiry to the public contact endpoint
  // (POST /api/public/contact). The returned promise resolves on a
  // successful submission and rejects on validation/transport failure,
  // so the Contact page can surface its error state and retain the
  // visitor's entered values (Requirements 7.3, 7.5).
  submitEnquiry (enquiry) {
    return PublicApi().post('public/contact', enquiry)
  },

  // Fetches a fresh self-hosted proof-of-work challenge for the contact form
  // (GET /api/public/altcha-challenge). Resolves to the challenge object, or
  // null when the server has proof-of-work disabled (HTTP 204) — in which case
  // the form submits without a solution and the honeypot alone guards it.
  async fetchChallenge () {
    const res = await PublicApi().get('public/altcha-challenge')
    if (res.status === 204 || !res.data) return null
    return res.data
  }
}
